export const LABEL_PLACEMENT = {
  top: "top",
  right: "right",
  bottom: "bottom",
  left: "left",
};
